import React from "react";

import useTaskState from "../../../hooks/useTaskState";

import Tabs from "./Tabs";
import ObjectiveInfo from "./ObjectiveInfo";
import TaskInfo from "./TaskInfo";

const ObjectivesDetails = ({
  team,
  plan,
  objectives, 
  selectedObjective, 
  isPlanOwner,
  showAddTaskButton,
  showTaskActions,
  showTaskProgressAction,
  showNoteEditor,
  onObjectiveSelect
}) => {

  const { task, setTask, loading } = useTaskState(selectedObjective?.tasks);

  return (
    <div className="objectives-details">
      <Tabs
        selectedObjective={selectedObjective}
        objectives={objectives}
        onTabSelect={onObjectiveSelect}
      />
      <div className="details">
        <ObjectiveInfo
          team={team}
          plan={plan}
          objective={selectedObjective}
          selectedTask={task}
          showAddTaskButton={showAddTaskButton}
          onTaskSelect={setTask}
        />
        <TaskInfo
          plan={plan}
          objective={selectedObjective}
          task={task}
          isPlanOwner={isPlanOwner}
          showTaskActions={showTaskActions}
          showTaskProgressAction={showTaskProgressAction}
          showNoteEditor={showNoteEditor}
        />
      </div>
    </div>
  );
}

export default ObjectivesDetails;
